import {
  parseEncampRepresentative,
  SCOUT_ENCAMP_REPRESENTATIVE_TOOL_NAME,
} from "./scoutEncampRepresentative";
import { DECREMENT_PRO_CREDIT_USAGE_TOOL_NAME, parseScoutProCreditUsage } from "./scoutProCredit";
import { ScoutProCreditBanner } from "./ScoutProCreditBanner";
import { parseScoutProUpsell, PRESENT_SCOUT_PRO_UPSELL_TOOL_NAME } from "./scoutProUpsell";
import { ScoutProUpsellCard } from "./ScoutProUpsellCard";
import { ScoutRepresentativeInline } from "./ScoutRepresentativeInline";
import { defineScoutToolCard } from "./scoutToolCard";

/**
 * Tools whose output renders as a card right under their tool-call group, in
 * place of a trace row. Add a row here to give a tool an inline card.
 */
export const SCOUT_INLINE_TOOL_CARDS = [
  defineScoutToolCard({
    toolName: PRESENT_SCOUT_PRO_UPSELL_TOOL_NAME,
    hideTraceRow: true,
    parse: parseScoutProUpsell,
    render: (upsell) => <ScoutProUpsellCard upsell={upsell} />,
  }),
  defineScoutToolCard({
    toolName: SCOUT_ENCAMP_REPRESENTATIVE_TOOL_NAME,
    hideTraceRow: true,
    parse: parseEncampRepresentative,
    render: () => <ScoutRepresentativeInline />,
  }),
  defineScoutToolCard({
    toolName: DECREMENT_PRO_CREDIT_USAGE_TOOL_NAME,
    hideTraceRow: true,
    parse: parseScoutProCreditUsage,
    render: (usage) => <ScoutProCreditBanner usage={usage} />,
  }),
];
